import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import groupBy from 'lodash/groupBy';

import TabsShowcase from './TabsShowcase';
import { FILTERKEYS } from './constants';

const TabsList = ({ content }) => {
  const dataGroup = groupBy(content, 'type');
  const dataKeys = Object.keys(dataGroup);

  return (
    <Fragment>
      {dataKeys.map(group => (
        <section key={`${group}-tabs-group`}>
          <h2 className="h2 page-subtitle">{FILTERKEYS[group]}</h2>
          <ul className="showcase-list">
            {
              dataGroup[group].map(group => (
                group.previews.map((tabs, i) => (
                  <li key={`tabs-${group.type}-showcase-${i}`}>
                    <TabsShowcase {...tabs} />
                  </li>
                ))
              ))
            }
          </ul>
        </section>
      ))}
    </Fragment>
  );
};

TabsList.propTypes = {
  content: PropTypes.arrayOf(PropTypes.object)
};

TabsList.displayName = 'TabsList';

export default TabsList;



// WEBPACK FOOTER //
// ./src/containers/elements/Tabs/TabsList.js